import { render, staticRenderFns } from "./ViewGreenCoffeeModal.vue?vue&type=template&id=3842e260&scoped=true"
import script from "./ViewGreenCoffeeModal.vue?vue&type=script&lang=js"
export * from "./ViewGreenCoffeeModal.vue?vue&type=script&lang=js"
import style0 from "./ViewGreenCoffeeModal.vue?vue&type=style&index=0&id=3842e260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3842e260",
  null
  
)

export default component.exports